import { isEmpty } from './array';
import { isNil } from './object';
import { parseIntElseNull } from './numbers';

// This version is known to be able to support WebM frame extraction correctly: Version 75.0.3770.100
export const CHROME_VERSION_WITH_WEBM_EXTRACTION_FIX = {
  build: 3770,
  major: 75,
  minor: 0,
  patch: 100,
};

export function getChromeVersion(userAgentString = navigator.userAgent) {
  const userAgentParts = userAgentString.match(
    /Chrom(?:e|ium)\/([0-9]+)\.([0-9]+)\.([0-9]+)\.([0-9]+)/,
  );
  if (isEmpty(userAgentParts) || userAgentParts.length !== 5) {
    return undefined;
  }
  return {
    build: parseIntElseNull(userAgentParts[3]),
    major: parseIntElseNull(userAgentParts[1]),
    minor: parseIntElseNull(userAgentParts[2]),
    patch: parseIntElseNull(userAgentParts[4]),
  };
}

export function isChromeVersionAtLeast(options) {
  const { build, major, minor, patch, userAgentString } = options;
  const currentChromeVersion = getChromeVersion(userAgentString);
  if (isNil(currentChromeVersion)) {
    return false;
  }
  if (currentChromeVersion.major > major) {
    return true;
  } else if (currentChromeVersion.major === major) {
    if (currentChromeVersion.minor > minor) {
      return true;
    } else if (currentChromeVersion.minor === minor) {
      if (currentChromeVersion.build > build) {
        return true;
      } else if (currentChromeVersion.build === build) {
        return currentChromeVersion.patch >= patch;
      }
    }
  }
  return false;
}

export const IS_MACINTOSH = navigator.platform.indexOf('Mac') === 0;
export const IS_SAFARI =
  navigator.userAgent.indexOf('Safari') !== -1 &&
  navigator.userAgent.indexOf('Chrome') === -1;
export const IS_CHROME = !!getChromeVersion();
